import React from 'react';
import PropTypes from 'prop-types';
import defaultPropTypes from '../../../utils/prop-types';
import { withTempSelection } from '../../../utils/convenience';
import { trackHCLClinicClick } from '../../../../../../../js/project/tracking-gtm-ga4';
var ListItem = function ListItem(props) {
  var scrollTopListTop = function scrollTopListTop() {
    window.scroll({
      top: props.locationsListRef.current.getBoundingClientRect().top + window.scrollY,
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "locations-list-item ".concat(props.layoutType, " ").concat(props.index % 2 ? 'even' : 'odd', " ").concat(props.location.equals(props.selectedLocation) || props.location.equals(props.tempSelectedLocation) ? 'selected' : ''),
    onClick: function onClick(e) {
      props.onSelectLocation(props.location);
      props.onOpenLocation(props.location, e);
      window.DGS.Event.getInstance().trigger('trackLocationsClinicClick', props.location.Name, props.location.PostalCode);
      trackHCLClinicClick("".concat(props.location.Name, " - ").concat(props.location.PostalCode));
      scrollTopListTop();
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        props.onSelectLocation(props.location);
        props.onOpenLocation(props.location);
        window.DGS.Event.getInstance().trigger('trackLocationsClinicClick', props.location.Name, props.location.PostalCode);
        trackHCLClinicClick("".concat(props.location.Name, " - ").concat(props.location.PostalCode));
        scrollTopListTop();
      }
    },
    role: "button",
    tabIndex: props.index
  }, /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement("strong", null, props.location.Name)), /*#__PURE__*/React.createElement("div", {
    className: "address"
  }, props.location.FormattedAddress), props.location.Phone && /*#__PURE__*/React.createElement("div", {
    className: "phone"
  }, props.settings.dictionary.phone, ":", ' ', /*#__PURE__*/React.createElement("a", {
    href: "tel:".concat(props.location.Phone),
    onClick: function onClick(e) {
      e.stopPropagation();
      props.onPhoneClick(props.location);
    }
  }, props.location.Phone)), /*#__PURE__*/React.createElement("div", {
    className: "opening-hours",
    dangerouslySetInnerHTML: {
      __html: props.location.OpeningHours
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "distance"
  }, /*#__PURE__*/React.createElement("i", null, "".concat(props.distance, " ").concat(props.settings.Unit, " ").concat(props.userLocation.Name.length ? props.settings.dictionary.fromSearchedLocation + ' ' + props.userLocation.Name : props.settings.dictionary.fromYourLocation)))), /*#__PURE__*/React.createElement("div", {
    className: "cta"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "button"
  }, props.settings.dictionary.info))));
};
export default withTempSelection(ListItem);
ListItem.propTypes = {
  settings: defaultPropTypes.settings.isRequired,
  location: defaultPropTypes.location.isRequired,
  distance: PropTypes.string.isRequired,
  tempSelectedLocation: defaultPropTypes.location.isRequired,
  selectedLocation: defaultPropTypes.location.isRequired,
  onSelectLocation: defaultPropTypes.func.isRequired,
  onOpenLocation: defaultPropTypes.func.isRequired,
  onPhoneClick: PropTypes.func,
  layoutType: defaultPropTypes.layoutType.isRequired,
  index: PropTypes.number.isRequired,
  locationsListRef: defaultPropTypes.func.isRequired
};
ListItem.defaultProps = {
  onPhoneClick: function onPhoneClick() {}
};